<div class="p-1">
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{(id) ? 'Edit' : 'הוספת מוצר חדש'}} </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="formAddProduct"  *ngIf="formAddProduct" (ngSubmit)="onSubmit()" autocomplete="off" fxLayout="row wrap">
                <div fxFlex="40" class="px-2">
                    <p class="mt-1"><span class="uppercase fw-500">{{'TOBA LIGHT.product.Gallery' | translate}}</span><span class="text-muted px-1">{{'TOBA LIGHT.product.maxImages' | translate}}</span></p>
                    <input-file formControlName="images" fileLimit="8" fileAccept="image/*"></input-file>
                </div>
                <div fxFlex="60" class="px-2">
                    <div fxLayout="row wrap">
                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label> {{'TOBA LIGHT.label.name' | translate}}</mat-label>
                                <input matInput formControlName="name" required>
                                <mat-error *ngIf="formAddProduct.controls.name.errors?.required">{{'TOBA LIGHT.label.Required' | translate}}</mat-error>
                                <mat-error *ngIf="formAddProduct.controls.name.hasError('minlength')">{{'TOBA LIGHT.label.IsentLongEnough' | translate}}</mat-error>
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" *ngIf="categories?.length>0">
                            <app-search-field [(myModel)]="selectedMainCategory" [options]="categories" [dataStructure]="{name:'name', value:'id', title:'TOBA LIGHT.category.parentCategory' | translate}" ></app-search-field>
                        </div>
<!--                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1" *ngIf="categories != null">-->
<!--                            <mat-form-field appearance="outline" class="w-100">-->
<!--                                <mat-label>{{'TOBA LIGHT.label.Category' | translate}}</mat-label>-->
<!--                                <mat-select formControlName="mainCategory"  required >-->

<!--                                    <mat-option *ngFor="let cat of categories" [value]="cat.id">-->
<!--                                        <span>{{cat.name}}</span>-->
<!--                                    </mat-option>-->
<!--                                </mat-select>-->
<!--                                <mat-error *ngIf="formAddProduct.controls.mainCategory.errors?.required">{{'TOBA LIGHT.label.Required' | translate}}</mat-error>-->
<!--                            </mat-form-field>-->
<!--                        </div>-->

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.diameter' | translate}}</mat-label>
                                <input matInput formControlName="diameter" type="number">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.supplierPrice' | translate}}</mat-label>
                                <input matInput formControlName="supplierPrice" type="number">
                                <mat-error *ngIf="formAddProduct.controls.supplierPrice.errors?.required">{{'TOBA LIGHT.label.Required' | translate}}</mat-error>
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.clientPrice' | translate}}</mat-label>
                                <input matInput formControlName="clientPrice" type="number">
                                <mat-error *ngIf="formAddProduct.controls.clientPrice.errors?.required">{{'TOBA LIGHT.label.Required' | translate}}</mat-error>
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.warehouse.quantity' | translate}}</mat-label>
                                <input matInput formControlName="availibilityCount" type="number">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.lumen' | translate}}</mat-label>
                                <input matInput formControlName="lumen" type="number">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.height' | translate}}</mat-label>
                                <input matInput formControlName="height" type="number">
                            </mat-form-field>
                        </div>


                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.lighting' | translate}}</mat-label>
                                <input matInput formControlName="lighting" type="string">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.ledType' | translate}}</mat-label>
                                <input matInput formControlName="ledType" type="string">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.ledPower' | translate}}</mat-label>
                                <input matInput formControlName="ledPower" type="string">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.weight' | translate}}</mat-label>
                                <input matInput formControlName="weight" type="number">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.illuminationAngles' | translate}}</mat-label>
                                <input matInput formControlName="illuminationAngles" type="number">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.width' | translate}}</mat-label>
                                <input matInput formControlName="width" type="number">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.length' | translate}}</mat-label>
                                <input matInput formControlName="length" type="number">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.lightHue' | translate}}</mat-label>
                                <input matInput formControlName="lightHue" type="string">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.voltage' | translate}}</mat-label>
                                <input matInput formControlName="voltage" type="number">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.bore' | translate}}</mat-label>
                                <input matInput formControlName="bore" type="number">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.cri' | translate}}</mat-label>
                                <input matInput formControlName="cri" type="number">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.barCode' | translate}}</mat-label>
                                <input matInput formControlName="barCode" type="string">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="legacy" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.generatedBarcode' | translate}}</mat-label>
                                <input matInput formControlName="generatedBarcode" type="string">
                                <button [disabled]="barcodeDisabled"  (click)="generateBarcode($event)"> צור פרקוד</button>
                            </mat-form-field>

                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.warranty' | translate}}</mat-label>
                                <input matInput formControlName="warranty" type="string">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Color' | translate}}</mat-label>
                                <mat-select formControlName="color" multiple  (selectionChange)="onColorSelectionChange($event)">
                                    <mat-option *ngFor="let color of colors" [value]="color.id">
                                        <div fxLayout="row" fxLayoutAlign="space-between center">
                                            <span>{{color.name}}</span>
                                            <div style="background-size: contain; border-radius: 50px; width: 18px; height: 18px; margin-left: 1.1rem;" *ngIf="color.image != null"  [style.backgroundImage]="'url('+color.image+')'"></div>
                                            <mat-icon *ngIf="!color.image"  [style.color]="color.code">fiber_manual_record</mat-icon>
                                        </div>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>


<!--                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1" >-->
<!--                            <mat-form-field appearance="outline" class="w-100">-->
<!--                                <mat-label>{{'TOBA LIGHT.label.Size' | translate}}</mat-label>-->
<!--                                <mat-select formControlName="size" multiple (selectionChange)="onSizeSelectionChange($event)">-->
<!--                                    <mat-option *ngFor="let s of sizes" [value]="s.id">-->
<!--                                        <span>{{s.width}}X{{s.height}}</span>-->
<!--                                    </mat-option>-->
<!--                                </mat-select>-->
<!--                            </mat-form-field>-->
<!--                        </div>-->
                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.workHours' | translate}}</mat-label>
                                <input matInput formControlName="workHours" type="number">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.deviceStatus' | translate}}</mat-label>
                                <input matInput formControlName="deviceStatus" type="string">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.depth' | translate}}</mat-label>
                                <input matInput formControlName="depth" type="string">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.discount' | translate}}</mat-label>
                                <input matInput formControlName="discount" type="number">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.ratingsCount' | translate}}</mat-label>
                                <input matInput formControlName="ratingsCount" type="number">
                            </mat-form-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.Product.ratingsValue' | translate}}</mat-label>
                                <input matInput formControlName="ratingsValue" type="number">
                            </mat-form-field>
                        </div>
                        <div class="form-group" [class]="getDrawerClass">
                            <div class="row">
                                <div class="col-3">
                                    <label>שורה</label>
                                    <input type="number" (blur)="isDrawerExist()" formControlName="row" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.row.errors }" />
                                    <div *ngIf="submitted && f.row.errors" class="invalid-feedback">
                                        <div *ngIf="f.row.errors.required">row is required</div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <label>עמודה</label>
                                    <input type="number" (blur)="isDrawerExist()" formControlName="column" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.column.errors }" />
                                    <div *ngIf="submitted && f.column.errors" class="invalid-feedback">
                                        <div *ngIf="f.column.errors.required">column is required</div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <label>שכבה</label>
                                    <input type="number" (blur)="isDrawerExist()" formControlName="layer" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.layer.errors }" />
                                    <div *ngIf="submitted && f.layer.errors" class="invalid-feedback">
                                        <div *ngIf="f.layer.errors.required">layer is required</div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <label>הוספת מגירה</label><br>
                                    <button type="button" [disabled]="drawerCreateBtnFlg!=-1" (click)="addDrawerBtn()" class="btn btn-primary">הוספה +</button>
                                </div>
                            </div>
                        </div>

                        <div fxFlex="100" class="px-1">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{'TOBA LIGHT.label.description' | translate}}</mat-label>
                                <textarea matInput formControlName="description" rows="7"></textarea> 
                            </mat-form-field> 
                        </div>



                        <div fxFlex="100" class="mt-2 text-center w-100">
                            <!--<button mat-raised-button color="primary" type="submit">{{'TOBA LIGHT.label.submit' | translate}} </button>-->
                            <button mat-raised-button color="primary" type="submit" (click)="saveProduct()" >{{'TOBA LIGHT.label.submit' | translate}}</button>
                        </div>
                    </div>
                </div>
            </form>
        </mat-card-content>
       
       
        
    </mat-card>
</div>
